import React, { useState } from "react";
import { EditorState, Modifier } from "draft-js";

const MergeTagOption = ({ onChange, editorState, mergeTagsData }) => {
  const [expanded, setExpanded] = useState(false);
  const [search, setSearch] = useState("");

  const dropDownStyle = {
    height: "40px",
    zIndex: 1
  };

  const selectTag = (tag) => {
    tag.value = tag.value.includes("&lt;") ? tag.value.replace("&lt;", "<") : tag.value;
    tag.value = tag.value.includes("&gt;") ? tag.value.replace("&gt;", ">") : tag.value;
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      tag.value,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, "insert-characters"));
  };
  return (
    <div
      className="rdw-dropdown-wrapper"
      style={{ width: "15%" }}
      aria-label="rdw-dropdown"
      onClick={() => setExpanded(!expanded)}
    >
      <a className="rdw-dropdown-selectedtext" title="Merge tags">
        <span>Merge tags</span>
        <div className={expanded ? "rdw-dropdown-carettoclose" : "rdw-dropdown-carettoopen"}></div>
      </a>
      {expanded ? (
        <ul className="rdw-dropdown-optionwrapper" style={{ width: "310px" }}>
          <li
            className="rdw-dropdownoption-default rdw-list-dropdownOption"
            style={{
              display: "flex",
              justifyContent: "space-between",
              position: "sticky",
              top: "0",
              opacity: 1,
              borderBottom: "1px solid #dfe0e2",
              background: "white"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              style={{ width: "100%", height: "60%" }}
              type="text"
              placeholder="search.."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </li>
          {mergeTagsData
            .filter((d) => search === "" || d.name.toLowerCase().includes(search.toLowerCase()))
            .map((tag) => {
              return (
                <li
                  className="rdw-dropdownoption-default"
                  style={tag.value ? { ...dropDownStyle } : { ...dropDownStyle, background: "#dfe0e2" }}
                  onMouseOver={tag.value ? (e) => (e.target.style.background = "#F1F1F1") : ""}
                  onMouseLeave={tag.value ? (e) => (e.target.style.background = "white") : ""}
                  onClick={() => selectTag(tag)}
                >
                  {tag.name}
                </li>
              );
            })}
        </ul>
      ) : (
        ""
      )}
    </div>
  );
};

export default MergeTagOption;
